
import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import { Search } from 'lucide-react';
import classes from "./PrintActivity.module.css"
import plus from "../../../Assets/plus.svg"
import run from "../../../Assets/run.svg"
import MailLogo from "../../../Assets/mail.svg"
import PrintLogo from "../../../Assets/print.svg"
import DownloadLogo from "../../../Assets/down.svg"
import BackLogo from "../../../Assets/back.svg"
import RotatingLogo from '../../../Assets/rotating-logo.png'
import EyeIcon from "../../../Assets/new-eye.svg"
import DeleteIcon from "../../../Assets/new-delete.svg"
import PencilIcon from "../../../Assets/pencil.svg"
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { Spinner, Badge, Button, Modal, Form } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import HeaderNav from "../../Accoungting/HeaderNav/HeaderNav";
import axios from "axios";
import { BASE_URL } from "../../../Components/Styles/API/API";
import { useLocation, useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import download from "../../../Assets/download1.svg"
import upload from "../../../Assets/upload.svg"
import logo from "../../../Assets/rotating-logo.png";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Multiselect from "../../../Components/Multiselect";
import ExcelLogo from "../../../Assets/excel.png"
import PdfLogo from "../../../Assets/pdf.png"
import * as XLSX from 'xlsx'; // Import xlsx library
import { saveAs } from 'file-saver';
import jsPDF from "jspdf";
import "jspdf-autotable";










const PrintActivity = () => {
  const location = useLocation();
const [noData, setNoData] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectOptions, setSelectOptions] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [load, setLoad] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [tableData3, setTableData3] = useState([]);
  const [tableData4, setTableData4] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState('');
  const [selectedProvince22, setSelectedProvince22] = useState('');
  const [selectedRegion, setSelectedRegion] = useState('');
  const [selectedContinent, setSelectedContinent] = useState('');
  const [tableData45, setTableData45] = useState([]);
  const [totalDebit, setTotalDebit] = useState('');
  const [totalCredit, setTotalCredit] = useState('');
  const [allAccounts, setAllAccounts] = useState([]);
  const [fetchingLoading, setFetchingLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedBank, setSelectedBank] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [searchedResult, setSearchedResult] = useState([]);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [bearer, setBearer] = useState('');
  const [user, setUser] = useState('');
  const [error, setError] = useState(null);
  const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalEntries, setTotalEntries] = useState("");
  const [loanCode, setLoanCode] = useState("");
  const [loanDescription, setLoanDescription] = useState("");
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [savingsLoading, setSavingsLoading] = useState(false);
  const [show1, setShow1] = useState(false);
  const [cashbook, setCashbook] = useState([]);
  const [tableData, setTableData] = useState([]);
   const [selectedIds, setSelectedIds] = useState([]);
  const navigate = useNavigate();
  const [benLoading, setBenLoading] = useState(false);
  const [statLoading, setStatLoading] = useState(false);
  const [stat, setStat] = useState([]);
  const [currentMonth, setCurrentMonth] = useState("");
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedEndDate, setSelectedEndDate] = useState('');
  const [inputss, setInputss] = useState([]);
  const [loadings, setLoadings] = useState(false);
  const [continent, setContinent] = useState('');
  const [region, setRegion] = useState('');
  const [province, setProvince] = useState('');
  const [admin, setAdmin] = useState('');
     const [usert, setUsert] = useState("");
 const [provin, setProvin] = useState("");
  const [regio, setRegio] = useState("");
  const [contin, setContin] = useState("");

  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');
      const current = await localStorage.getItem('currentMonth');
      const admins = await localStorage.getItem('admin');
      // const saved = localStorage.getItem("cashbook_preview");
      const continentName = await localStorage.getItem('continent');
      const regionName = await localStorage.getItem('region');
      const provinceName = await localStorage.getItem('province');
         const provinceid = await localStorage.getItem('provinceID');
      const continentid = await localStorage.getItem('continentID');
      const regionid = await localStorage.getItem('regionID');
      const usertype = await localStorage.getItem('userType');

      if (value !== null) {
        setBearer(value);
      }
      // if (saved) {
      //   setCashbook(JSON.parse(saved));
      // }

      if (value1 !== null) {
        setUser(value1);
      }
        if (provinceid !== null) {
        setProvin(provinceid);
      }
      if (continentid !== null) {
        setContin(continentid);
      }
      if (regionid !== null) {
        setRegio(regionid);
      }
      if (usertype !== null) {
        setUsert(usertype);
      }
      if (current !== null) {
        console.log(current);
        const date = new Date(current);

        setCurrentMonth(date);

        const startOfDateRange = new Date(1900, 0, 1);

        const endOfDateRange = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        // Format date function as 'YYYY-MM-DD'
        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };

        setMinDate(formatDate(startOfDateRange));
        setMaxDate(formatDate(endOfDateRange));

        console.log("Date Range:", formatDate(startOfDateRange), "to", formatDate(endOfDateRange));
      }
      if (admins !== null) {
        setAdmin(admins);
      }
      if (continentName !== null) {
        setContinent(continentName);
      }
      if (regionName !== null) {
        setRegion(regionName);
      }
      if (provinceName !== null) {
        setProvince(provinceName);
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };


const handleChange = (selected) => {
    // Check if "Select All" was clicked
    if (selected?.some((opt) => opt.value === "ALL")) {
      if (selectedOptions.length === allAccounts.length) {
        // If all are already selected -> unselect all
        setSelectedOptions([]);
        handleBank([]); // pass empty back
      } else {
        // Otherwise select everything
        setSelectedOptions(allAccounts);
        handleBank(allAccounts);
      }
    } else {
      setSelectedOptions(selected || []);
      handleBank(selected || []);
    }
  };

  // prepend "Select All" option
  const optionsWithAll = [{ value: "ALL", label: "Select All" }, ...allAccounts];





  const handleShow1 = (loan) => {
    setLoanCode(loan.code);
    setLoanDescription(loan.description);
    setSelectedReportTo(loan.reportTo);
    setShow1(true);
  };

  const handleClose1 = () => setShow1(false);


  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const handleCustomers = async () => {
    setBenLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/fetch-pending-sales-invoice-paginated?page=${currentPage}`, { headers });
      const results = response.data?.data?.data;
      const resultx = response.data?.data?.total;
      setTotalEntries(resultx);
      setTableData(results);
      console.log(results, "From Remittane")
      const total = response.data?.data?.last_page || 1;
      setTotalPages(total);

    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response?.data && error.response?.data.message) {
          if (typeof error.response?.data.message === 'string') {
            errorMessage = error.response?.data.message;
          } else if (Array.isArray(error.response?.data.message)) {
            errorMessage = error.response?.data.message.join('; ');
          } else if (typeof error.response?.data.message === 'object') {
            console.log(errorMessage);
            setError(errorMessage)
          }
        }
        setTableData([]);
      }
    } finally {
      setBenLoading(false);
    }

  };

  useEffect(() => {
    if (bearer) {
      handleCustomers();
    }
  }, [bearer, currentPage]);

 const fetchAccounts = async () => {
  setSavingsLoading(true);
  try {
    const response = await axios.get(`${BASE_URL}/reports/activity-report`, {
      params: {
        // continent_id: usert == '2' ? selectedContinent : "",
        //   region_id: usert == '3' ? selectedRegion : "",
          // province_id: usert == '4' ? selectedProvince : "",
          account_id: selectedIds,
          start_date: selectedDate,
          end_date: selectedEndDate,
          continent_id: usert == '2' ? contin : selectedContinent || "",
          region_id: usert == '3' ? regio : selectedRegion || "",
          province_id: usert == '4' ? provin : selectedProvince || ""
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${bearer}`
      }
    });

    if (!response.data?.data?.journal || response.data?.data?.journal.length === 0) {
      setAccounts([]);   // ✅ clear previous data
      setNoData(true);
      return;
    }

    const resultsss = response.data?.data?.journal;
    const resultssx = response.data?.data?.input;

    setAccounts(resultsss);
    setInputss(resultssx);
    setNoData(false);

    console.log(resultsss);

  } catch (error) {
    if (error.response && error.response.status === 401) {
      navigate('/login');
    } else {
      console.log(error);
      setAccounts([]);   // ✅ also clear here on error
      setNoData(true);
    }
  } finally {
    setSavingsLoading(false);
  }
};


 useEffect(() => {
    if (accounts) {
      const creditTotal = accounts
        .filter((item) => !isNaN(item.nCredit) && item.nCredit !== '')
        .reduce((total, item) => total + parseFloat(item.nCredit), 0);

      const debitTotal = accounts
        .filter((item) => !isNaN(item.nDebit) && item.nDebit !== '')
        .reduce((total, item) => total + parseFloat(item.nDebit), 0);

      // Format the numbers with commas and two decimal places
      const formattedDebitTotal = debitTotal?.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      const formattedCreditTotal = creditTotal?.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      setTotalDebit(formattedDebitTotal);
      setTotalCredit(formattedCreditTotal);
    }
  }, [accounts]);

  const groupedData = accounts.reduce((acc, item) => {
    if (!acc[item.gl_code]) {
      acc[item.gl_code] = [];
    }
    acc[item.gl_code].push(item);
    return acc;
  }, {});

  const getFiscalMonth = (transactionDate) => {
  const date = new Date(transactionDate);
  const calendarMonth = date.getMonth(); // 0-11
  // Fiscal month: Sep = 0, Oct = 1, ..., Aug = 11
  const fiscalMonth = (calendarMonth + 4) % 12 + 1; // Shift so Sep=1, Aug=12
  return fiscalMonth.toString().padStart(2, '0');
};


  const calculateTotals = (group) => {
    return group[0]?.journals?.reduce(
      (totals, item) => {
        totals.debit += parseFloat(item.debit) || 0;
        totals.credit += parseFloat(item.credit) || 0;
        return totals;
      },
      { debit: 0, credit: 0 }
    );
  };


  const filteredAccounts = accounts.filter((item) => {
    const term = searchTerm.toLowerCase();
    return (
      item.details?.toLowerCase().includes(term) ||
      item.cheque_number?.toLowerCase().includes(term) ||
      item.transaction_date?.toLowerCase().includes(term)
    );
  });


  const fetchAccountss = async () => {
    console.log(headers)
    setLoadings(true);

    try {
      const response = await axios.get(`${BASE_URL}/account`, { headers });

      const CustomOption = (props) => {
        const { data, innerRef, innerProps } = props;
        return (
          <div ref={innerRef} {...innerProps}>
            <span style={{ color: 'blue' }}>{data?.gl_code}</span>
            {' - '}
            <span style={{ color: 'red', fontWeight: 'bold' }}>{data?.gl_name}</span>
          </div>
        );
      };

      const allAccts = response.data?.data;
      const opt1 = allAccts.map((item) => ({
        label: `${item.gl_code} - ${item.gl_name}`,
        value: item.id,
      }));
      setAllAccounts(opt1);

      //   console.log(allAccts, "All Accounts");
    } catch (error) {
      const errorStatus = error.response?.data.message;
      console.error(errorStatus);
    } finally {
      setLoadings(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchAccountss();
    }
  }, [bearer]);


 const handleSelectionChange = (ids) => {
    console.log("Selected IDs:", ids);
    setSelectedIds(ids);
  };



  function formatDates(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  const handlePrevPage = () => {
    setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
  };

  const formattedTotalEntries = totalEntries?.toLocaleString();

  const fetchStat = async () => {
    setStatLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/customer/total-customers`, { headers });
      const stas = response.data?.data;

      setStat(stas);

    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            console.log(errorMessage);
          }
        }
        setStat([]);
      }
    } finally {
      setStatLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchStat();

    }
  }, [bearer]);

  const formatStat = (value) => {
    if (value == null) return "";

    if (value >= 1000 && value < 1000000) {
      const rounded = value / 1000;
      // If divisible by 1000 exactly, no decimals (30k)
      if (value % 1000 === 0) {
        return `${rounded}k`;
      }
      // Else show 2 decimals (30.01k)
      return `${rounded.toFixed(2)}k`;
    }

    if (value >= 1000000) {
      const rounded = value / 1000000;
      if (value % 1000000 === 0) {
        return `${rounded}M`;
      }
      return `${rounded.toFixed(2)}M`;
    }

    // smaller than 1000 → just locale string with commas
    return value?.toLocaleString("en-US");
  };

  const isSearching = searchTerm.trim() !== "" && searchedResult.length > 0;
  const handleDateChange1 = (event) => {
    setSelectedEndDate(event.target.value);
  };

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  const handleBank = (selectedOption) => {
    setSelectedBank(selectedOption);
  };

  const handleCreate = () => {

  }

  const fetchContinents = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/continents`, { headers });
      const results = response.data?.data;

      const options = results.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      // setCustomers(results);
      setSelectOptions(options);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setCustomers([]);
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    if (bearer) {
      fetchContinents();
    }
  }, [bearer]);



  const fetchSubContinents = async () => {
    setLoad(true);
    try {
      const response = await axios.get(`${BASE_URL}/regions`, { headers });

      // console.log(response);
      const subCont = response.data?.data?.regions;
      const options1 = subCont.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setTableData3(options1);
      // console.log(results);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
        setTableData3([]);
      }
    } finally {
      setLoad(false);
    }
  };

  const fetchSubRegion = async () => {
    setLoad(true);
    try {
      const response = await axios.get(`${BASE_URL}/regions/getprovincesregion?region_id=${selectedRegion}`, { headers });

      // console.log(response);
      const subCont1 = response.data?.data;
      const options2 = subCont1.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setTableData4(options2);
      console.log(options2);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
        setTableData3([]);
      }
    } finally {
      setLoad(false);
    }
  };
  const fetchProvince = async () => {
    setLoad(true);
    try {
      const response = await axios.get(`${BASE_URL}/provinces`, { headers });

      // console.log(response);
      const subCont15 = response.data?.data.provinces;
      const options25 = subCont15.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setTableData45(options25);
      console.log(response);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
        setTableData3([]);
      }
    } finally {
      setLoad(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchSubContinents();
    }
  }, [bearer]);

  useEffect(() => {
    if (bearer && selectedRegion) {
      fetchSubRegion(selectedRegion);
    }
  }, [bearer, selectedRegion]);

  useEffect(() => {
    if (bearer) {
      fetchProvince();
    }
  }, [bearer]);

  const handleContinentChange = (selectedOption) => {
    setSelectedContinent(selectedOption.value);
    setSelectedRegion('');
    setSelectedProvince('');
  };


  const handleRegionChange = (selectedOption) => {
    setSelectedRegion(selectedOption.value)
  }

  const handleProvinceChange = (selectedOption) => {
    setSelectedProvince(selectedOption.value)
    setSelectedProvince22(selectedOption.value)
  }



  function formatDate(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  useEffect(() => {
    if (accounts) {
      const debitTotal = accounts?.reduce((total, item) => total + parseFloat(item.debit), 0);
      const creditTotal = accounts?.reduce((total, item) => total + parseFloat(item.credit), 0);

      // Format the numbers with commas and two decimal places
      const formattedDebitTotal = debitTotal?.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      const formattedCreditTotal = creditTotal?.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      setTotalDebit(formattedDebitTotal);
      setTotalCredit(formattedCreditTotal);
    }
  }, [accounts]);

const tableRef = useRef(null);

const handlePrint = () => {
  window.print();
};

const exportToExcel = async () => {
  if (!groupedData || Object.keys(groupedData).length === 0) {
    console.log("No data available to export");
    return;
  }

  const sheetData = [];
  const fmt = (val) => parseFloat(val || 0);
  const getFiscalMonth = (dateStr) =>
    dateStr ? new Date(dateStr).toLocaleString("default", { month: "short" }) : "";

  // --- HEADERS ---
  sheetData.push(["The Redeemed Christian Church Of God"]);
  sheetData.push([province === "undefined" ? admin : province]);
  sheetData.push(["Account Activity Report"]);
  sheetData.push([`Period: ${inputss?.start_date || "-"} to ${inputss?.end_date || "-"}`]);
  sheetData.push([""]);

  // Table Headers (8 columns)
  sheetData.push([
    "ACCOUNT",
    "NAME",
    "MONTH",
    "DATE",
    "DESCRIPTION",
    "STAFF",
    "DEBIT",
    "CREDIT",
  ]);

  Object.keys(groupedData).forEach((glCode) => {
    const head = groupedData[glCode][0];

    const totalDebit =
      head.journals?.reduce((sum, j) => sum + fmt(j.debit), 0) || 0;
    const totalCredit =
      head.journals?.reduce((sum, j) => sum + fmt(j.credit), 0) || 0;

    // --- Group Header ---
    sheetData.push([
      head.gl_name,
      "",
      "",
      "",
      "Beginning Balance",
      "",
      fmt(head.opening_balance),
      "",
    ]);

    // --- Journals ---
    head.journals?.forEach((j) => {
      sheetData.push([
        head.gl_code,
        j.name,
        getFiscalMonth(j.transaction_date),
        j.transaction_date,
        j.details,
        `${j?.transaction?.activity?.name || ""} – ${j?.transaction?.activity?.employee_no || ""}`,
        fmt(j.debit),
        fmt(j.credit),
      ]);
    });

    // --- Totals ---
    sheetData.push([
      "TOTALS",
      "",
      "",
      "",
      "",
      "",
      totalDebit,
      totalCredit,
    ]);

    // --- Closing Balance ---
    sheetData.push([
      "CLOSING BALANCE",
      "",
      "",
      "",
      "",
      "",
      fmt(head.closing_balance),
      "",
    ]);

    sheetData.push([""]); // Spacer
  });

  const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "AccountActivity");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const file = new Blob([excelBuffer], {
    type: "application/octet-stream",
  });

  saveAs(file, `Account_Activity_Report_${inputss?.end_date}.xlsx`);
};



const exportToPDF = () => {
  if (!groupedData || Object.keys(groupedData).length === 0) return;

  const doc = new jsPDF("p", "mm", "a4");
  const pageWidth = doc.internal.pageSize.getWidth();

  const formatCurrency = (val) =>
    parseFloat(val || 0).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const getFiscalMonth = (dateStr) =>
    dateStr ? new Date(dateStr).toLocaleString("default", { month: "short" }) : "";

  // --- HEADER ---
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("The Redeemed Christian Church Of God", pageWidth / 2, 15, {
    align: "center",
  });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(12);
  doc.text(province === "undefined" ? admin : province || "", pageWidth / 2, 22, {
    align: "center",
  });

  doc.text("Account Activity Report", pageWidth / 2, 28, { align: "center" });

  doc.setFontSize(10);
  doc.text(
    `Period: ${inputss?.start_date || "--"} to ${inputss?.end_date || "--"}`,
    pageWidth / 2,
    34,
    { align: "center" }
  );

  // --- TABLE DATA ---
  const tableRows = [];

  Object.keys(groupedData).forEach((glCode) => {
    const head = groupedData[glCode][0];

    const totalDebit =
      head.journals?.reduce((s, j) => s + (parseFloat(j.debit) || 0), 0) || 0;
    const totalCredit =
      head.journals?.reduce((s, j) => s + (parseFloat(j.credit) || 0), 0) || 0;

    // Group Header
    tableRows.push({
      type: "GROUP_HEADER",
      col1: head.gl_name,
      col2: "",
      col3: "",
      col4: "",
      col5: "Beginning Balance",
      col6: "",
      col7: formatCurrency(head.opening_balance),
      col8: "",
    });

    // Journals
    head.journals?.forEach((j) => {
      tableRows.push({
        type: "DATA",
        col1: head.gl_code,
        col2: j.name,
        col3: getFiscalMonth(j.transaction_date),
        col4: j.transaction_date,
        col5: j.details,
        col6: `${j?.transaction?.activity?.name || ""}\n${j?.transaction?.activity?.employee_no || ""}`,
        col7: parseFloat(j.debit) > 0 ? formatCurrency(j.debit) : "--",
        col8: parseFloat(j.credit) > 0 ? formatCurrency(j.credit) : "--",
        rawDebit: parseFloat(j.debit),
        rawCredit: parseFloat(j.credit),
      });
    });

    // Totals
    tableRows.push({
      type: "TOTALS",
      col1: "TOTALS",
      col2: "",
      col3: "",
      col4: "",
      col5: "",
      col6: "",
      col7: formatCurrency(totalDebit),
      col8: formatCurrency(totalCredit),
    });

    // Closing
    tableRows.push({
      type: "CLOSING",
      col1: "CLOSING BALANCE",
      col2: "",
      col3: "",
      col4: "",
      col5: "",
      col6: "",
      col7: formatCurrency(head.closing_balance),
      col8: "",
    });

    tableRows.push({ type: "SPACER" });
  });

  // --- DRAW TABLE ---
  doc.autoTable({
    startY: 40,
    theme: "plain",
    styles: {
      fontSize: 8,
      cellPadding: 2,
      overflow: "linebreak", // 🔥 ENABLE WRAP
    },
    headStyles: {
      fillColor: [241, 245, 249],
      fontStyle: "bold",
    },
    head: [
      [
        "ACCOUNT",
        "NAME",
        "MONTH",
        "DATE",
        "DESCRIPTION",
        "STAFF",
        "DEBIT",
        "CREDIT",
      ],
    ],
    body: tableRows.map((r) => [
      r.col1,
      r.col2,
      r.col3,
      r.col4,
      r.col5,
      r.col6,
      r.col7,
      r.col8,
    ]),
    columnStyles: {
      0: { cellWidth: 18 },
      1: { cellWidth: 25, overflow: "linebreak" }, // NAME wrap
      2: { cellWidth: 14 },
      3: { cellWidth: 18 },
      4: { cellWidth: 35 },
      5: { cellWidth: 35, overflow: "linebreak" }, // STAFF wrap
      6: { cellWidth: 20, halign: "right" },
      7: { cellWidth: 20, halign: "right" },
    },
    didParseCell: (data) => {
      const row = tableRows[data.row.index];
      if (!row) return;

      if (row.type === "GROUP_HEADER") {
        data.cell.styles.fontStyle = "bold";
        data.cell.styles.textColor = [59, 130, 246];
      }

      if (row.type === "TOTALS") {
        data.cell.styles.fontStyle = "bold";
        if (data.column.index === 6) data.cell.styles.textColor = [255, 0, 0];
        if (data.column.index === 7) data.cell.styles.textColor = [0, 128, 0];
      }

      if (row.type === "CLOSING") {
        data.cell.styles.fontStyle = "bold";
        data.cell.styles.fillColor = [207, 217, 235];
      }
    },
  });

  doc.save("AccountActivityReport.pdf");
};




  return (
    <div style={{ backgroundColor: "#f9f9f9", minHeight: "100vh" }}>
      <HeaderNav />

      <div className={classes.topContainer}>
         <div className={classes.backTxt}>
          <img src={BackLogo} alt="back" className={classes.iconBtn} onClick={() => navigate(-1)} />
          <div className={classes.bckText}>
            <h3 className={classes.topText}>Account Activity Report</h3>
            {/* <p className={classes.prgText}>Account Activity Report between the period of {inputss?.start_date
    ? new Date(inputss?.start_date).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "--"} to {inputss?.end_date
    ? new Date(inputss?.end_date).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "--"}</p> */}
          </div>
          
        </div>
        <div style={{ marginTop: 12 }} />
        <div className={classes.topNavBars}>
          <div className={classes.filterRow}>
            {/* Left side: Inputs */}
            <div className={classes.filterInputs}>
              {/* Account */}
               {admin === "Regional Accountant" && (
                                            <div className={classes.inlineField}>
                                              <label className={classes.inlineLabel}>Provinces:</label>
                                              <Select
                                                onChange={handleProvinceChange}
                                                options={tableData45}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                  container: (provided) => ({
                                                    ...provided,
                                                    width: 200, // ✅ fixed width
                                                    fontSize: 12, // applies to the wrapper
                                                  }),
                                                  control: (provided) => ({
                                                    ...provided,
                                                    minHeight: "36px",
                                                    fontSize: 12, // ✅ font size inside control
                                                  }),
                                                  singleValue: (provided) => ({
                                                    ...provided,
                                                    fontSize: 12, // ✅ selected value text
                                                  }),
                                                  option: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: 12, // ✅ dropdown option text
                                                    backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                                                    color: "#111827",
                                                  }),
                                                  menu: (provided) => ({
                                                    ...provided,
                                                    maxHeight: "300px",
                                                    maxWidth: "200px",
                                                    overflowY: "auto",
                                                    fontSize: 12, // ✅ font size in menu
                                                  }),
                                                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                }}
                                                className={classes.inlineSelect}
                                              />
                              
                                            </div>
                                            )}

                                            {admin === "Continental Accountant" && (
                                <div style={{display: "flex", gap: 20}}>
                                <div className={classes.inlineField}>
                                <label className={classes.inlineLabel}>Region:</label>
                                <Select
                                  onChange={handleRegionChange}
                                  options={tableData3}
                                  menuPortalTarget={document.body}
                                  styles={{
                                    container: (provided) => ({
                                      ...provided,
                                      width: 200, // ✅ fixed width
                                      fontSize: 12, // applies to the wrapper
                                    }),
                                    control: (provided) => ({
                                      ...provided,
                                      minHeight: "36px",
                                      fontSize: 12, // ✅ font size inside control
                                    }),
                                    singleValue: (provided) => ({
                                      ...provided,
                                      fontSize: 12, // ✅ selected value text
                                    }),
                                    option: (provided, state) => ({
                                      ...provided,
                                      fontSize: 12, // ✅ dropdown option text
                                      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                                      color: "#111827",
                                    }),
                                    menu: (provided) => ({
                                      ...provided,
                                      maxHeight: "300px",
                                      maxWidth: "200px",
                                      overflowY: "auto",
                                      fontSize: 12, // ✅ font size in menu
                                    }),
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                  }}
                                  className={classes.inlineSelect}
                                />
                
                              </div>

                              <div className={classes.inlineField}>
                                <label className={classes.inlineLabel}>Provinces:</label>
                                <Select
                                  onChange={handleProvinceChange}
                                  options={tableData4}
                                  menuPortalTarget={document.body}
                                  styles={{
                                    container: (provided) => ({
                                      ...provided,
                                      width: 200, // ✅ fixed width
                                      fontSize: 12, // applies to the wrapper
                                    }),
                                    control: (provided) => ({
                                      ...provided,
                                      minHeight: "36px",
                                      fontSize: 12, // ✅ font size inside control
                                    }),
                                    singleValue: (provided) => ({
                                      ...provided,
                                      fontSize: 12, // ✅ selected value text
                                    }),
                                    option: (provided, state) => ({
                                      ...provided,
                                      fontSize: 12, // ✅ dropdown option text
                                      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                                      color: "#111827",
                                    }),
                                    menu: (provided) => ({
                                      ...provided,
                                      maxHeight: "300px",
                                      maxWidth: "200px",
                                      overflowY: "auto",
                                      fontSize: 12, // ✅ font size in menu
                                    }),
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                  }}
                                  className={classes.inlineSelect}
                                />
                
                              </div>
                              </div>
                              )}

              <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>Account:</label>
                <Multiselect options={allAccounts} onChange={handleSelectionChange}/>
              {/* <Select
  isMulti
  value={selectedOptions}
  onChange={handleChange}
  options={optionsWithAll}
  menuPortalTarget={document.body}
  styles={{
    container: (provided) => ({
      ...provided,
      width: 200,
      fontSize: 12,
    }),
    control: (provided) => ({
      ...provided,
      minHeight: "36px",
      maxHeight: "36px",       // ✅ lock the height
      fontSize: 12,
      overflow: "hidden",
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: "36px",       // ✅ fix container height
      overflowY: "auto",       // ✅ scroll inside instead of growing
    }),
    multiValue: (provided) => ({
      ...provided,
      fontSize: 12,
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: 12,
      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
      color: "#111827",
    }),
    menu: (provided) => ({
      ...provided,
      maxHeight: "300px",
      maxWidth: "200px",
      overflowY: "auto",
      fontSize: 12,
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  }}
/> */}


              </div>

              {/* Start Date */}
              <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>Start Date:</label>
                <input
                  className="form-control"
                  type="date"
                  onChange={handleDateChange}
                  value={selectedDate}
                  style={{fontSize: 14}}
                  min={minDate}
                  max={maxDate}
                  required
                />
              </div>

              {/* End Date */}
              <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>End Date:</label>
                <input
                  className="form-control"
                  type="date"
                  onChange={handleDateChange1}
                  value={selectedEndDate}
                  min={minDate}
                   style={{fontSize: 14}}
                  max={maxDate}
                  required
                />
              </div>
              <button className={classes.loanBtn} onClick={fetchAccounts}> <img src={run} alt="run-report" /> Run Report </button>
            </div>

            {/* Right side: 3 icons */}
            
          </div>


        </div>
        <div style={{ marginTop: 24 }} />
       
        <div  className={classes.tableContainer}>
         {accounts.length === 0 ? (
             <div
               style={{
                 textAlign: "center",
                 padding: "40px",
                 fontSize: "18px",
                 color: "#374151",
               }}
             >
               <p>No data to display</p>
             </div>
           ) : (
             <>
               <div className={classes.sideTools}>
                 {accounts.length > 0 && (
                   <div className={classes.filterIcons}>
                     <img
                       src={MailLogo}
                       alt="icon1"
                       className={classes.iconBtns}
                       onClick={() => console.log("icon1")}
                     />
                     <img
                       onClick={() => handlePrint()}
                       src={PrintLogo}
                       alt="icon2"
                       className={classes.iconBtns}
                     />
                    <img
              onClick={() => exportToExcel()}
              src={ExcelLogo}
              alt="icon3"
              className={classes.iconBtns}
            />
            <img
              onClick={() => exportToPDF()}
              src={PdfLogo}
              alt="icon3"
              className={classes.iconBtns}
            />
                   </div>
                 )}
               </div>
          <div className={classes.cntrTable}>
            <h1 className={classes.cntrTxt}>The Redeemed Christian Church Of God</h1>
             <p className={classes.cntrTxt12}>{province === 'undefined' ? admin : province}</p>
              <p className={classes.cntrTx122}>Account Activity Report
                       between the period of {" "} {inputss?.start_date
                         ? new Date(inputss?.start_date).toLocaleDateString("en-US", {
                             year: "numeric",
                             month: "long",
                             day: "numeric",
                           })
                         : "--"} to {" "}
                       {inputss?.end_date
                         ? new Date(inputss?.end_date).toLocaleDateString("en-US", {
                             year: "numeric",
                             month: "long",
                             day: "numeric",
                           })
                         : "--"}
                     </p>
            {/* <p className={classes.cntrTx1}>Activi</p> */}
            {/* <p className={classes.cntrTx2}>
  For the period ended{" "}
  {inputss?.end_date
    ? new Date(inputss?.end_date).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "--"}
</p> */}

          </div>
 <table style={{ width: "100%", borderCollapse: "collapse", marginTop: 20 }}>
          <thead>
            <tr style={{borderBottom: "1px solid #d1d5db",}}>
              <th style={{ textAlign: 'left', fontSize: 14, padding: "8px",}}>ACCOUNT</th>
              {/* <th style={{ textAlign: 'left', fontSize: 14, padding: "8px",}}>NAME</th> */}
              <th style={{ textAlign: 'left', fontSize: 14, padding: "8px",}}>MONTH</th>
              <th style={{ textAlign: 'left', fontSize: 14, padding: "8px",}}>DATE</th>
              <th style={{ textAlign: 'left', fontSize: 14, padding: "8px", }}>DESCRIPTION</th>
              <th style={{ textAlign: 'left', fontSize: 14, padding: "8px", }}>STAFF</th>
              {/* <th style={{ textAlign: 'left', fontSize: 14, padding: "8px", }}></th> */}
              <th style={{ textAlign: 'right', fontSize: 14, padding: "8px", }}>DEBIT</th>
              <th style={{ textAlign: 'right', fontSize: 14, padding: "8px", }}>CREDIT</th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(groupedData).map((gl_code) => {
              const group = groupedData[gl_code];
              const totals = calculateTotals(group);
              return (
                <React.Fragment key={gl_code}>
                  <tr>
                    <td colSpan="1" style={{ textAlign: "left",
                color: "#3B82F6",
                fontWeight: 700,
                fontSize: 14,
                padding: "8px", }}>{group[0]?.gl_name}</td>
                <td></td>
                    <td colSpan="4" style={{ color: "#3B82F6",
                fontWeight: 700,
                fontSize: 14,
                padding: "8px", paddingLeft: "10px", textAlign: 'right' }}>Beginning Balance</td>
                
                    <td colSpan="1" style={{ textAlign: 'right', color: "#3B82F6",
                fontWeight: 700,
                fontSize: 14,
                padding: "8px", }}>
                      {group[0]?.opening_balance?.toLocaleString('en-US', { minimumIntegerDigits: 1, minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </td>
                  </tr>
                  {group[0]?.journals?.map((item, index) => (
                    <tr key={index} style={{borderBottom: "1px solid #d1d5db", borderCollapse: "collapse"}}>
                      <td style={{ padding: "8px", fontSize: 14,   }}>{group[0]?.gl_code}</td>
                      {/* <td style={{ padding: "8px", fontSize: 14,   }}>{item.name}</td> */}
                      <td style={{ padding: "8px", fontSize: 14,  whiteSpace: 'nowrap' }}>{getFiscalMonth(item.transaction_date)}</td>
                      <td style={{ padding: "8px", fontSize: 14,  whiteSpace: 'nowrap' }}>{item.transaction_date}</td>
                      <td style={{
                    padding: "8px",
                    maxWidth: "400px",
                    whiteSpace: "normal",
                    fontSize: 14
                  }}>{item.details}</td>
                      {/* <td style={{
                    padding: "8px",
                    whiteSpace: "normal",
                    overflowWrap: "break-word",
                    fontSize: 12
                  }}></td> */}
                  {/* <td></td> */}
                  <td style={{
                    padding: "8px",
                    // maxWidth: "90px",
                    whiteSpace: "normal",
                  }} >  {item?.transaction?.activity 
                    ? `${item.transaction.activity.name} – ${item.transaction.activity.employee_no}` 
                    : "--"}</td>
                      <td style={{
                    padding: "8px",
                    textAlign: "right",
                    color: "red",
                    fontSize: 14
                  }}>{Number(item.debit) > 0
                    ? Number(item.debit).toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : "--"}</td>
                      <td style={{ padding: "8px",
                    textAlign: "right",
                    fontSize: 14,
                    color: "green"}}>{Number(item.credit) > 0
                ? Number(item.credit).toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                : "--"}</td>
                    </tr>
                  ))}
                
  {/* Totals row */}
  <tr>
    <td colSpan="5" 
        style={{ padding: "6px", fontWeight: 700, fontSize: 13, textAlign: "left" }}>
      TOTALS
    </td>
    {/* <td></td> */}
    <td style={{ 
        padding: "6px", 
        textAlign: "right", 
        color: "red", 
        fontWeight: 700, 
        fontSize: 13 
      }}>
      {totals.debit?.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}
    </td>
    <td style={{ 
        padding: "6px", 
        textAlign: "right", 
        color: "green", 
        fontWeight: 700, 
        fontSize: 13 
      }}>
      {totals.credit?.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}
    </td>
  </tr>

  {/* Closing balance row */}
  <tr style={{ background: `linear-gradient(#CFD9EB66, #CFD9EB)` }}>
    <td colSpan="6" 
        style={{ 
          fontSize: 14, 
          color: "black", 
          fontWeight: 700, 
          padding: "6px", 
          textAlign: "left" 
        }}>
      CLOSING BALANCE
    </td>
    {/* <td></td> */}
    <td style={{ 
        padding: "6px", 
        textAlign: "right", 
        color: "#16A34A", 
        fontWeight: 700, 
        fontSize: 15 
      }}>
      {group[0]?.closing_balance?.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}
    </td>
  </tr>


                </React.Fragment>
              );
            })}
          </tbody>
        </table>
         
        

         


 </>
  )}
        </div>
     <div style={{ marginTop: 27 }} />
    {/* {accounts?.length > 0 && (
        <div className={classes.cardContainer}>
  {(() => {
    const openingBalance = parseFloat(accounts[0]?.opening_balance || 0);

    
    let totalDebit = 0;
    let totalCredit = 0;

    accounts.forEach((item) => {
      totalDebit += parseFloat(item.debit) || 0;
      totalCredit += parseFloat(item.credit) || 0;
    });

    const closingBalance = parseFloat(accounts[0]?.closing_balance || 0);

    const stats = [
      {
        label: "Opening Balance",
        value: openingBalance,
        labelColor: "#2563EB",
      },
      
      {
        label: "Total Debits",
        value: totalDebit,
        labelColor: "#EF4444",
      },
      {
        label: "Total Credits",
        value: totalCredit,
        labelColor: "#16A34A",
      },
      {
        label: "Closing Balance",
        value: closingBalance,
        labelColor: "#A855F7",
      },
    ];

    return stats.map((item, idx) => (
      <div className={classes.statCard} key={idx}>
        
        <h3 className={classes.cardValue}>
          <span style={{ color: item.labelColor }}>
            {item.value?.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </span>
        </h3>

       
        <div className={classes.cardHeader}>
          <p className={classes.cardLabel}  style={{ color: item.labelColor }}>{item.label}</p>
        </div>
      </div>
    ));
  })()}
</div>
)} */}
      </div>
      {savingsLoading && (
        <div className={classes.overlay}>
          <img src={RotatingLogo} alt="Loading..." className={classes.spinnerLogo} />
        </div>
      )}

    </div>
  )
}

export default PrintActivity
